import dataType from '../dataType';

const lookup = {
    name: 'Lookup',
    type: dataType.string
};

export default lookup;
